import axios from "axios";
import { appUrl } from "../../../../utils/config";
import * as dummy from "./forecastDummyData";

// ===========================================================================
// DUMMY DATA SWITCH
// ---------------------------------------------------------------------------
// Set USE_DUMMY_DATA = false to revert all calls below to the real backend
// once the APIs are ready. No other change is required.
// ===========================================================================
const USE_DUMMY_DATA = true;

const DUMMY_DELAY_MS = 400;

const dummyResponse = (data) =>
  new Promise((resolve) => setTimeout(() => resolve(data), DUMMY_DELAY_MS));

const base = () =>
  `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}`;

const userBase = () => `${appUrl}/user`;

const post = async (path, payload, signal) => {
  const res = await axios.post(`${base()}/${path}`, payload || {}, { signal });
  return res.data;
};

const get = async (path, signal) => {
  const res = await axios.get(`${base()}/${path}`, { signal });
  return res.data;
};

export const saveFilters = async (forecastDashboard, signal) => {
  // if (USE_DUMMY_DATA) return dummyResponse(dummy.saveFiltersResponse);
  const res = await axios.post(
    `${userBase()}/saveFilters`,
    { forecastDashboard },
    { signal }
  );
  return res.data;
};

export const fetchAllFilters = async (signal) => {
  // if (USE_DUMMY_DATA) return dummyResponse(dummy.fetchAllFiltersResponse);
  const res = await axios.get(`${userBase()}/fetchAllFilters`, { signal });
  return res.data;
};

export const fetchCMOMembers = (signal) => {
  // if (USE_DUMMY_DATA) return dummyResponse(dummy.fetchCMOMembersResponse);
  return post("fetchCMOMembers", {}, signal);
};

export const fetchSponsorsForCMO = async (data, signal) => {
  // if (USE_DUMMY_DATA) return dummyResponse(dummy.fetchSponsorsForCMOResponse);
  const res = await axios.post(`${base()}/fetchSponsorsForCMO`,
    data,
    { signal }
  );
  return res.data;
  // return get("fetchSponsorsForCMO", signal);
};

export const fetchBrandValues = (signal) => {
  // if (USE_DUMMY_DATA) return dummyResponse(dummy.fetchBrandValuesResponse);
  return get("fetchBrandValues", signal);
};

export const fetchMfgPlants = (signal) => {
  // if (USE_DUMMY_DATA) return dummyResponse(dummy.fetchMfgPlantsResponse);
  return get("fetchMfgPlants", signal);
};

export const fetchForecasts = (payload, signal) => {
  console.log(payload)
  // if (USE_DUMMY_DATA) return dummyResponse(dummy.buildFetchForecastsResponse(payload));
  return post("fetchForecasts", payload, signal);
};

export const updateForecastDetails = (payload, signal) => {
  console.log(payload)
  // if (USE_DUMMY_DATA) return dummyResponse(dummy.updateForecastDetailsResponse);
  return post("updateForecastDetails", payload, signal);
};

export const fetchForecastHistory = (payload, signal) => {
  console.log(payload)
  // if (USE_DUMMY_DATA) return dummyResponse(dummy.fetchForecastHistoryResponse);
  return post("fetchForecastHistory", payload, signal);
};

export const fetchForecastChatData = (payload, signal) => {
  console.log(payload)
  // if (USE_DUMMY_DATA) return dummyResponse(dummy.fetchForecastChatDataResponse);
  return post("fetchForecastChatData", payload, signal);
};

export const addForecastChatData = (payload, signal) => {
  console.log(payload)
  // if (USE_DUMMY_DATA)
  //   return dummyResponse(dummy.buildAddForecastChatDataResponse(payload));
  return post("addForecastChatData", payload, signal);
};

const SIMULATE_APPROVE_FAILURE = false;

export const approveForecast = () =>
  new Promise((resolve, reject) => {
    setTimeout(() => {
      if (SIMULATE_APPROVE_FAILURE) {
        reject(new Error("Something went wrong"));
      } else {
        resolve({ status: true });
      }
    }, 1500);
  });
